export default __webpack_public_path__ + "static/media/wilson-rolland-garros-all-court.c4df945e.jpg";